import { render } from "./Updates.vue?vue&type=template&id=1e25d60d"
import script from "./Updates.vue?vue&type=script&lang=js"
export * from "./Updates.vue?vue&type=script&lang=js"

import "./Updates.vue?vue&type=style&index=0&id=1e25d60d&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__